/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        this.currentQuantities[item.dataset.variantId] = Number(item.querySelector('.qty-input__input').value);
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      this.updateQuantity(evt.target.dataset.index, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
        const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
        const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
        const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

        this.enableLoading(line);

        const lineErrorsId = `line-item-error-${line}`;
        const lineErrors = document.getElementById(lineErrorsId);
        document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
          el.innerHTML = '';
          el.hidden = true;
        });

        const sections = this.getSectionsToRender().map((section) => section.section);
        this.fetchRequestOpts.body = JSON.stringify({
          line,
          quantity,
          sections: [...new Set(sections)],
          sections_url: window.location.pathname
        });

        try {
          const lineItem = document.getElementById(`cart-item-${line}`);
          const productId = Number(lineItem.dataset.productId);
          const variantId = Number(lineItem.dataset.variantId);
          const oldTotalQuantity = this.currentTotalItemCount;

          const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
          const data = await response.json();

          if (!response.ok) throw new Error(data.errors || response.status);

          const newTotalQuantity = data.item_count;

          if (this.cartDrawer) {
            cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);
            if (newTotalQuantity === 0) {
              const recommendations = this.cartDrawer.querySelector('product-recommendations');
              if (recommendations) recommendations.remove();
            }
          } else if (newTotalQuantity === 0) {
            const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
            if (cartTitle) cartTitle.style.textAlign = 'center';
            const cartSummaryCss = document.getElementById('cart-summary-css');
            if (cartSummaryCss) cartSummaryCss.remove();
            const cartSummary = document.getElementById('cart-summary');
            if (cartSummary) cartSummary.hidden = true;
          }

          /* Die kompakten Upsell-Zeilen (g24-cart-upsell) liegen weder in
             cart-items noch in einem der anderen Container, die unten neu
             gefuellt werden: auf der Warenkorbseite in .cart-page-recommendations,
             im Drawer nackt zwischen #cart-promoted-products und
             #cart-drawer-media-promotion. Sie blieben deshalb im leeren
             Warenkorb stehen. Die Shopify-Rueckfallebene fiel nicht auf, weil
             product-recommendations oben gezielt entfernt wird. */
          if (newTotalQuantity === 0) {
            document.querySelectorAll('.g24-upsell').forEach((upsell) => {
              (upsell.closest('.cart-page-recommendations') || upsell).remove();
            });
          }

          this.getSectionsToRender().forEach((section) => {
            const sectionEl = document.getElementById(section.id);
            if (!sectionEl) return;
            const { selector } = section;
            const el = sectionEl.querySelector(selector) || sectionEl;
            el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
          });

          if (this.cartDrawer && newTotalQuantity === 0) {
            cartDrawerContent.classList.add('grow', 'flex', 'items-center');

            /* cart-drawer.liquid gibt .cart-drawer__content im leeren
               Warenkorb "grow flex flex-col w-full" mit. Diese Klassen
               stehen hinter einer Liquid-Bedingung und werden beim
               AJAX-Refresh nicht neu gesetzt; ohne sie schrumpft der
               Container unter dem items-center des Elternteils. */
            const cartDrawerInner = this.cartDrawer.querySelector('.cart-drawer__content');
            if (cartDrawerInner) cartDrawerInner.classList.add('grow', 'flex', 'flex-col', 'w-full');
            if (this.cartDrawer.querySelector('promoted-products')) {
              this.cartDrawer
                .querySelector('.drawer__content')
                .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
            }
          }

          window.initLazyImages();
          this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
          this.updateLiveRegions();
          this.setFocus(line, newTotalQuantity, name);
          this.dataset.empty = newTotalQuantity === 0;
          this.currentTotalItemCount = newTotalQuantity;

          if (oldTotalQuantity !== newTotalQuantity) {
            console.log('updateQuantity() changed productId', productId);
            try {
              const cartResponse = await fetch('/cart.js');
              const cart = await cartResponse.json();

              const warrantyIndex = cart.items.findIndex(item => {
                return item.properties &&
                      Number(item.properties.RelatedProductVarient) === variantId;
              });

              if (warrantyIndex !== -1) {
                const warrantyLine = warrantyIndex + 1;
                const warrantyItem = cart.items[warrantyIndex];

                if (Number(quantity) === 0) {
                  console.log('Removing warranty because main product qty is 0');
                  await fetch(theme.routes.cartChange, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      line: warrantyLine,
                      quantity: 0,
                    }),
                  });
                } else if (warrantyItem.quantity !== Number(quantity)) {
                  console.log('Updating warranty quantity to match main product');
                  await fetch(theme.routes.cartChange, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      line: warrantyLine,
                      quantity: Number(quantity),
                    }),
                  });
                }
              } else {
                console.log('No related warranty cart item found for main variantId:', variantId);
              }
            } catch (err) {
              console.error('Error syncing warranty product:', err);
            }

            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: data,
                variantId,
                oldQuantity: this.currentQuantities[variantId],
                newQuantity: Number(quantity)
              }
            }));
          }

          this.currentQuantities[variantId] = Number(quantity);
          lineErrors.innerHTML = '';
          lineErrors.hidden = true;

          // ---- after successful update and warranty sync, run your drawer refresh logic ----
          setTimeout(async () => {
            $("#upsellDetailsModal").fadeOut();
            $("body").removeClass("upsellDetailsModal_open");
            try {
              const response = await fetch(`${theme.routes.cart}.js`);
              if (!response.ok) throw new Error(response.status);
              const cartData = await response.json();
              const cartDrawer = document.querySelector("cart-drawer");
              const cartItems = document.querySelector('cart-items');
               if (cartItems) {
                cartItems.refresh(true);
               // cartItems.renderContents(cartData, true);
               }
              if (cartDrawer) {
                cartDrawer.refresh(true);
                cartDrawer.renderContents(cartData, true);
                cartDrawer.setAttribute("open", "");
                cartDrawer.setAttribute("aria-hidden", "false");
                if (cartItems && typeof cartItems.refresh === 'function') {
                  cartItems.refresh();
                }
                document.querySelector('.header__icon.cart-icon')?.click();
              } else {
                console.warn("cart-drawer element not found.");
              }
            } catch (error) {
              console.error("Error updating cart drawer:", error);
            }
          }, 100);
          // ---- end drawer refresh ----

        } catch (error) {
          if (/^[0-9]+$/.test(error.message)) {
            lineErrors.textContent = theme.strings.cartError;
          } else {
            lineErrors.textContent = error.message;
          }
          lineErrors.hidden = false;
          console.log(error);

          this.querySelectorAll('.cart-item__loader').forEach((loader) => {
            loader.hidden = true;
          });

          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: error.message
            }
          }));

          const input = document.getElementById(`quantity-${line}`);
          input.value = input.dataset.initialValue;
          input.closest('quantity-input').currentQty = input.dataset.initialValue;
        } finally {
          this.classList.remove('pointer-events-none');

          if (cartDrawerContent) {
            requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
            setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
            requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
            setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
          }
        }
      }
   /* async updateQuantity(line, quantity, name) {
      console.log('gh');
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartSummary = document.getElementById('cart-summary');
          if (cartSummary) cartSummary.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        window.initLazyImages();
        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          lineErrors.textContent = theme.strings.cartError;
        } else {
          lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        input.value = input.dataset.initialValue;
        input.closest('quantity-input').currentQty = input.dataset.initialValue;
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }*/

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        window.initLazyImages();

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}
